import { createFeatureSelector } from '@ngrx/store';

import { RefreshSearchState, refreshSearchFeatureName } from '@shared/refresh-search/store/state/refresh-search.state';

export const refreshSearchSelector = createFeatureSelector<RefreshSearchState>(refreshSearchFeatureName);
